// extracted by mini-css-extract-plugin
export default {"heading1":"Heading_heading1__7zxWQ"};